import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Endpoints} from '../../shared/config/endpoints';
import {Store} from '@ngrx/store';
import {AppState} from '../../store/app.state';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InstagramService {
  private orgId: number;
  department: any;
  private baseUri = this.endpoints.instagramServiceUrl;
  postToView = new BehaviorSubject<any>({});

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    store: Store<AppState>
  ) {
    store.select('userInfo').subscribe((info) => {
      this.orgId = info.organization.id;
    });
    this.department = JSON.parse(localStorage.getItem('departmentInfo'));
  }

  instagramDetails(): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/details`);
  }

  instagramPageInsights(): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/insights`);
  }

  fetchPosts(after?: string, before?: string): Observable<any> {
    const params: any = {};
    if (after) {
      params.after = after;
    }
    if (before) {
      params.before = before;
    }
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/media`, {params});
  }

  fetchComments(mediaId: string) {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}/comments/${mediaId}`);
  }

  postComment(comment: string, mediaId: string) {
    return this.http.post(`${this.baseUri}/pages/${this.orgId}/comments/${mediaId}`, {comment});
  }

  replyComment(commentId: string, message: string): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/${this.orgId}/comment/${commentId}/replies`, {message}).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  deleteComment(commentId: string) {
    return this.http.delete(`${this.baseUri}/pages/${this.orgId}/comments/${commentId}`);
  }
}
